import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CreditCardTypeResponse } from '@app/core/models/openpay.model';
import { ICreditCard, IPaymentParams, IPaymentResponse } from '@app/core/models/payments.model';
import { environment } from '@environment';

import { Observable } from 'rxjs';
import { URLS } from './url.constants';

@Injectable({
  providedIn: 'root',
})
export class PaymentsAPI {
  constructor(private _http: HttpClient) {}

  public createPayments(paymentParams: IPaymentParams): Observable<IPaymentResponse> {
    return this._http.post<IPaymentResponse>(`${URLS.PAYMENTS}`, paymentParams);
  }

  public createCreditCard(creditCard: ICreditCard): Observable<void> {
    return this._http.post<void>(`${URLS.CREATE_CREDIT_CARD}`, creditCard);
  }

  public getCreditCardType(bines: string): Observable<CreditCardTypeResponse> {
    const baseUrl = environment.openpay_url;
    const merchantid: string = environment.openpay_merchant_id;
    return this._http.get<CreditCardTypeResponse>(
      `${baseUrl}${merchantid}/bines/${bines}/promotions`
    );
  }
}
